import {
  ServiceTypes,
  useGetServiceListNameIdQuery,
  type PostFilter,
} from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { sortBy, uniq } from "lodash";
import { useMemo, useState } from "react";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import {
  ItemGridFilterDataList,
  type FilterValueEntry,
} from "../ItemGridFilter/ItemGridFilterDataList";

type SupportedFilter = PostFilter | null | undefined;

export function ItemGridFilterFlyoutType() {
  const [query, setQuery] = useState<string>("");

  const { filter, updateFilterState } = useItemGridFilterContext();
  const { data, loading, error } = useGetServiceListNameIdQuery({
    variables: {
      page: 0,
      perPage: 1000,
      sortField: "name",
      sortOrder: "ASC",
      filter: {
        type: ServiceTypes.Flyout,
        q: query ? query : undefined,
      },
    },
  });

  const filterWithFlyoutType: SupportedFilter = filter;
  const items = useMemo<FilterValueEntry[]>(() => {
    const values: FilterValueEntry[] =
      data?.items
        ?.slice()
        ?.filter((item) => !!item?.id)
        ?.map((item) => {
          const id = item.id ?? "";
          const name = item.name ?? "";
          const checked =
            filterWithFlyoutType?.flyoutType?.includes(id) ?? false;
          return {
            id,
            name,
            checked,
          };
        }) ?? [];

    return sortBy(values, (entry) => entry.name);
  }, [data?.items, filterWithFlyoutType?.flyoutType]);

  return (
    <ItemGridFilterDataList
      error={error}
      items={items}
      loading={loading}
      property="flyoutType"
      text="Interactive Type"
      onQueryValueChanged={setQuery}
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.flyoutType;
          }
        })
      }
      onRequestFilterUpdate={(id, include) =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (include) {
              draft.flyoutType = uniq([...(draft.flyoutType ?? []), id]);
            } else if (draft.flyoutType?.length) {
              draft.flyoutType = draft.flyoutType.filter(
                (flyoutType) => flyoutType !== id,
              );
            }

            if (!draft.flyoutType?.length) {
              delete draft.flyoutType;
            }
          }
        })
      }
      onSelectAllChanged={(checked) => {
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (checked) {
              draft.flyoutType = data?.items
                ?.slice()
                ?.filter((item) => !!item?.id)
                ?.map((item) => item.id ?? "")
                ?.filter((id) => !!id);
            } else {
              delete draft.flyoutType;
            }
          }
        });
      }}
    />
  );
}
